import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { useStore } from "../../../contexts/StoreProvider";
import AddEditMzlReleaseForm from "../forms/add-edit-mzl-release-form";
import { IAddUpdateFotaMzlConfig } from "../../../models/response/IFotaNewResponse";
import { addEditFotaMzlConfigInitialState } from "../../../core/initial-state/add-edit-fota-mzl-config-initial-state";
import fotaViewTypeEnum from "../../../constants/fota-view-type-enum";
import toast from "react-hot-toast";
import { formatMessage } from "../../../translations/format-message";

interface IProps {
  id: number;
  modalClosed: () => void;
}



const AddEditMzlRelease = (props: IProps) => {
  const { fotaMzlReleaseStore } = useStore();
  const {
    error,
    inProgress,
    reset,
    setSelectedView,
    isSelectedView,
    setIsAddUpdatePopupOpen,
    AddFotaModemConfigService,
    UpdateFotaModemConfigService,
    AddFotaJetConfigService,
    UpdateFotaJetConfigService,
    addUpdateFotaState, resetAddUpdateFotaState,
    GetFotaModemConfigByIdService, GetFotaJetConfigByIdService, fotaMzlConfigDetailState,
    getFotaModemConfigDetail, getFotaJetConfigDetail
  } = fotaMzlReleaseStore;

  const initialValues: IAddUpdateFotaMzlConfig = addEditFotaMzlConfigInitialState;

  useEffect(() => {
    if (props.id > 0 && (isSelectedView.view == fotaViewTypeEnum.Modem)) {
      GetFotaModemConfigByIdService(props.id);
    }
    else if (props.id > 0 && (isSelectedView.view == fotaViewTypeEnum.Jet)) {
      GetFotaJetConfigByIdService(props.id);
    }
  }, []);


  useEffect(() => {
    if (addUpdateFotaState.success) {
      if (props.id > 0)
        toast.success(formatMessage("updated_success"));
      else
        toast.success(formatMessage("added_success"));

      onModalClosed();
    }
  }, [addUpdateFotaState.success]);

  const onModalClosed = () => {
    resetAddUpdateFotaState();
    props.modalClosed();
  };

  const handleSubmitMzlReleaseForm = (data: IAddUpdateFotaMzlConfig) => {
    let tempWantToUpdateFile = data.WantToUpdateFile === "true" ? true : false;
    const payload: any = {
      EffectiveDateTimestamp: data.EffectiveDateTimestamp,
      ConfigName: data.ConfigName,
      Version: data.Version,
      FileInString: data.File,
      FileType:
        typeof data.FileType === "string"
          ? parseInt(data.FileType)
          : data.FileType,
      Description: data.Description.trim(),
      FileName: data.FileName?.trim(),
    };
    if (props.id > 0) {
      isSelectedView.view == fotaViewTypeEnum.Modem ?
        UpdateFotaModemConfigService({
          ...payload,
          WantToUpdateFile: tempWantToUpdateFile,
          FileInString: tempWantToUpdateFile ? data.File : "",
          FileName: tempWantToUpdateFile ? data.FileName : "",
        }, props.id) :
        UpdateFotaJetConfigService({
          ...payload,
          WantToUpdateFile: tempWantToUpdateFile,
          FileInString: tempWantToUpdateFile ? data.File : "",
          FileName: tempWantToUpdateFile ? data.FileName : "",
        }, props.id);
    }
    else {
      isSelectedView.view == fotaViewTypeEnum.Modem ? AddFotaModemConfigService({ ...payload }) : AddFotaJetConfigService({ ...payload });
    }
  };



  return (
    <AddEditMzlReleaseForm
      initialValues={isSelectedView.view == fotaViewTypeEnum.Modem ? getFotaModemConfigDetail : getFotaJetConfigDetail}
      id={props.id}
      onModalClosed={onModalClosed}
      submitHandler={handleSubmitMzlReleaseForm}
      dataLoading={fotaMzlConfigDetailState.inProgress || inProgress}
      actionLoading={addUpdateFotaState.inProgress}
    />
  );
}
export default observer(AddEditMzlRelease);


